import { type EnclosureShape, ENCLOSURE_SHAPES } from '@frontend/api';
import {
  Box,
  GDTControlFrame,
  GDTSymbolText,
  type GDTControlFrameProps,
} from '@frontend/legacy-components';

const EnclosureShapeWrapper = ({
  enclosureShape,
  children,
}: {
  enclosureShape: EnclosureShape;
  children: React.ReactNode;
}) => {
  if (enclosureShape === ENCLOSURE_SHAPES.BOX) {
    return (
      <Box
        border="1px solid"
        borderColor="feature.primary"
        px={0.5}
        display="inline-flex"
        alignItems="center"
      >
        {children}
      </Box>
    );
  }

  if (enclosureShape === ENCLOSURE_SHAPES.OBROUND) {
    return (
      <Box
        border="1px solid"
        borderColor="feature.primary"
        px={1}
        borderRadius="full"
        display="inline-flex"
        alignItems="center"
      >
        {children}
      </Box>
    );
  }

  return <>{children}</>;
};

// Simple decision tree to determine whether to render a GDTControlFrame or a GDTSymbolText, or a raw label
export const FindingLabel = ({
  label,
  isGdt,
  controlFrameProps,
  enclosureShape,
  size = 'md',
}: {
  label: string;
  isGdt: boolean;
  controlFrameProps?: GDTControlFrameProps;
  enclosureShape?: EnclosureShape;
  size?: 'sm' | 'md';
}) => {
  if (controlFrameProps) {
    return (
      <GDTControlFrame
        {...controlFrameProps}
        size={size}
        sectionBoxProps={{
          borderColor: 'feature.primary',
        }}
      />
    );
  }

  const displayLabel =
    enclosureShape === ENCLOSURE_SHAPES.PARENTHESES ? `(${label})` : label;

  const hasShapeBorder =
    enclosureShape && enclosureShape !== ENCLOSURE_SHAPES.PARENTHESES;

  const content = isGdt ? (
    <GDTSymbolText
      size={size}
      {...(hasShapeBorder ? { lineHeight: '1.25' } : {})}
    >
      {displayLabel}
    </GDTSymbolText>
  ) : (
    displayLabel
  );

  if (hasShapeBorder) {
    return (
      <EnclosureShapeWrapper enclosureShape={enclosureShape}>
        {content}
      </EnclosureShapeWrapper>
    );
  }

  return <>{content}</>;
};
